module.exports = __webpack_public_path__ + "static/media/OBE_hero.85d3a3e9.jpg";